import styled from "styled-components";
import { spacingIncrement } from "../../utils/common";

export const FilterWrapper = styled.div`
  justify-content: space-between;
  gap: ${spacingIncrement(10)};
`;
